import {GetHealthProviderLocationParams, NetworkTypesEnum} from 'domain/usecases';
import {
	makeGetHealthFavoriteProviderLocation,
	makeGetHealthProviderLocation,
} from 'main/factories/usecases';
import {parseHealthUnits} from '../../utils/parseHealthUnits';
import {formatHealthUnit} from '../../utils/formatHealthUnit';
import {GetHealthProviderLocationParams as GetHealthProviderLocationParamsV1} from 'domain/usecases/private/booking-flow/health-V1';
import {makeGetHealthProviderLocation as makeGetHealthProviderLocationV1} from 'main/factories/usecases/private/booking-flow/remote-health-booking-v1';
import {Units} from 'presentation/modules/booking/shared/store/useUnitsListStore/types';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {GetHealthUnitsResponse} from './types';

export async function getHealthUnits(
	params: GetHealthProviderLocationParams,
): Promise<GetHealthUnitsResponse> {
	const unitFavoriteProviderLocationParams = {
		specialtyCode: String(params.specialtyCode),
		subSpecialtyCode: params?.subSpecialtyCode ? String(params.subSpecialtyCode) : '',
		providerCode: params.providerCode ? String(params.providerCode) : '',
		entryPointCode: params.entryPointCode ? String(params.entryPointCode) : '',
		signal: params.signal,
	};

	const isUnitFavoriteProviderLocationParamsValid = Boolean(
		params.specialtyCode && params.providerCode && params.entryPointCode,
	);

	const units = isUnitFavoriteProviderLocationParamsValid && params?.isFavoriteDoctorsFlow
		? await makeGetHealthFavoriteProviderLocation().get(unitFavoriteProviderLocationParams)
		: await makeGetHealthProviderLocation().get(params);

	if (!units) {
		return {
			unidadesPorLocal: [] as Units<FlowEnum.HEALTH>[],
			unidadesPorRaio: [] as Units<FlowEnum.HEALTH>[],
			name: NetworkTypesEnum.SELF,
		};
	}

	const listByLocality = units?.unidadesPorLocal;
	const listByDistance = units?.unidadesPorRaio;

	const parsedUnitsByLocality = listByLocality
		? parseHealthUnits({units: listByLocality, isAccreditedV2Network: false})
		: [];
	const parsedUnitsByDistance = listByDistance
		? parseHealthUnits({units: listByDistance, isAccreditedV2Network: false})
		: [];

	const formattedUnitsByLocality = formatHealthUnit(parsedUnitsByLocality, 'name');
	const formattedUnitsByDistance = formatHealthUnit(parsedUnitsByDistance, 'distance');

	const unitsFormatted = {
		unidadesPorLocal: formattedUnitsByLocality,
		unidadesPorRaio: formattedUnitsByDistance,
		name: units.rede,
	};

	return unitsFormatted;
}

export async function getHealthUnitsV1(
	params: GetHealthProviderLocationParamsV1,
	signal?: AbortSignal,
) {
	const units = await makeGetHealthProviderLocationV1().get({...params, signal});

	if (!units) {
		return {
			unidadesPorLocal: [] as Units<FlowEnum.HEALTH>[],
			unidadesPorRaio: [] as Units<FlowEnum.HEALTH>[],
			name: NetworkTypesEnum.SELF,
		};
	}

	const listByLocality = units?.unidadesPorLocal;
	const listByDistance = units?.unidadesPorRaio;

	const parsedUnitsByLocality = listByLocality
		? parseHealthUnits({units: listByLocality, isAccreditedV2Network: false})
		: [];
	const parsedUnitsByDistance = listByDistance
		? parseHealthUnits({units: listByDistance, isAccreditedV2Network: false})
		: [];

	const formattedUnitsByLocality = formatHealthUnit(parsedUnitsByLocality, 'name');
	const formattedUnitsByDistance = formatHealthUnit(parsedUnitsByDistance, 'distance');

	const unitsFormatted = {
		unidadesPorLocal: formattedUnitsByLocality,
		unidadesPorRaio: formattedUnitsByDistance,
		name: units.rede,
	};

	return unitsFormatted;
}
